import axiosInstance from "../axiosClient";
import { addCredentials, credentialDelete, credentialsList, postCredentials, updateCredentials, updateCredentialsDetail } from "../config";

export const getCredetials = async (name,limit,start_key) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.get(`${credentialsList}${queryString}`);
};

export const createCredentials =  async(data) => {
  return await axiosInstance.post(addCredentials,data);
};

export const deleteCredential = async (id) => {
  let queryParams = [];
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.delete(`${credentialDelete}${queryString}`);
}

export const postApicredentials= async(data)=>{
  return await axiosInstance.post(postCredentials,data)
}

export const handleCredentialsStatus= async(data)=>{
  return await axiosInstance.patch(updateCredentials,data)
}

export const updateCredentialsDetails = async (data) => {
  return await axiosInstance.put(updateCredentialsDetail, data);
};
